import type { TFunction } from 'i18next'
import { PresenceState } from '~/utils/xml'

export const enum PresenceKind {
  Extension = 'extension',
  Parking = 'parking',
}

/**
 * Text equivalent of a presence dot. A red (unavailable) parking spot holds a
 * parked call, so it reads "Occupied" instead of "Busy".
 */
export const getPresenceLabel = (
  t: TFunction,
  presence: PresenceState | undefined,
  kind: PresenceKind,
) => {
  switch (presence) {
    case PresenceState.Available:
      return t('quickDialListItem.presence.available', 'Available')
    case PresenceState.Connecting:
      return t('quickDialListItem.presence.ringing', 'Ringing')
    case PresenceState.Unavailable:
      return kind === PresenceKind.Parking
        ? t('quickDialListItem.presence.occupied', 'Occupied')
        : t('quickDialListItem.presence.busy', 'Busy')
    default:
      return t('quickDialListItem.presence.unknown', 'Unknown')
  }
}
